

export const suvData = [
  { label: "Florida", value: "Florida", abbreviation: "FL", rate: 600 },
  { label: "Georgia", value: "Georgia", abbreviation: "GA", rate: 660 },
  { label: "South Carolina", value: "South Carolina", abbreviation: "SC", rate: 700 },
  { label: "Alabama", value: "Alabama", abbreviation: "AL", rate: 640 },
  { label: "North Carolina", value: "North Carolina", abbreviation: "NC", rate: 700 },
  { label: "Tennessee", value: "Tennessee", abbreviation: "TN", rate: 950 },
  { label: "Kentucky", value: "Kentucky", abbreviation: "KY", rate: 950 },
  { label: "Mississippi", value: "Mississippi", abbreviation: "MS", rate: 850 },
  { label: "Louisiana", value: "Louisiana", abbreviation: "LA", rate: 900 },
  { label: "Delaware", value: "Delaware", abbreviation: "DE", rate: 1417.50 },
  { label: "Maryland", value: "Maryland", abbreviation: "MD", rate: 1290 },
  { label: "West Virginia", value: "West Virginia", abbreviation: "WV", rate: 1353 },
  { label: "Indiana", value: "Indiana", abbreviation: "IN", rate: 1287 },
  { label: "Ohio", value: "Ohio", abbreviation: "OH", rate: 1221 },
  { label: "Pennsylvania", value: "Pennsylvania", abbreviation: "PA", rate: 1155 },
  { label: "New Jersey", value: "New Jersey", abbreviation: "NJ", rate: 1039.50 },
  { label: "Maine", value: "Maine", abbreviation: "ME", rate: 1800 },
  { label: "New Hampshire", value: "New Hampshire", abbreviation: "NH", rate: 1524 },
  { label: "Vermont", value: "Vermont", abbreviation: "VT", rate: 1650 },
  { label: "Massachusetts", value: "Massachusetts", abbreviation: "MA", rate: 1523 },
  { label: "Connecticut", value: "Connecticut", abbreviation: "CT", rate: 1375 },
  { label: "Rhode Island", value: "Rhode Island", abbreviation: "RI", rate: 1650 },
  { label: "New York", value: "New York", abbreviation: "NY", rate: 1890 },
  { label: "Virginia", value: "Virginia", abbreviation: "VA", rate: 1320 },
  { label: "Michigan", value: "Michigan", abbreviation: "MI", rate: 1295 },
  { label: "Iowa", value: "Iowa", abbreviation: "IA", rate: 1300 },
  { label: "Kansas", value: "Kansas", abbreviation: "KS", rate: 1000 },
  { label: "Alaska", value: "Alaska", abbreviation: "AK", rate: 3450 },
  { label: "Arkansas", value: "Arkansas", abbreviation: "AR", rate: 1056 },
  { label: "Missouri", value: "Missouri", abbreviation: "MO", rate: 1104 },
  { label: "Illinois", value: "Illinois", abbreviation: "IL", rate: 1056 },
  { label: "Texas", value: "Texas", abbreviation: "TX", rate: 1008 },
  { label: "Oklahoma", value: "Oklahoma", abbreviation: "OK", rate: 1120 },
  { label: "Nebraska", value: "Nebraska", abbreviation: "NE", rate: 1275 },
  { label: "Wisconsin", value: "Wisconsin", abbreviation: "WI", rate: 1260 },
  { label: "Minnesota", value: "Minnesota", abbreviation: "MN", rate: 1328 },
  { label: "Colorado", value: "Colorado", abbreviation: "CO", rate: 1312 },
  { label: "South Dakota", value: "South Dakota", abbreviation: "SD", rate: 1440 },
  { label: "North Dakota", value: "North Dakota", abbreviation: "ND", rate: 1422 },
  { label: "New Mexico", value: "New Mexico", abbreviation: "NM", rate: 1463 },
  { label: "Arizona", value: "Arizona", abbreviation: "AZ", rate: 1520 },
  { label: "Montana", value: "Montana", abbreviation: "MT", rate: 1748 },
  { label: "Wyoming", value: "Wyoming", abbreviation: "WY", rate: 1672 },
  { label: "Utah", value: "Utah", abbreviation: "UT", rate: 1748 },
  { label: "Idaho", value: "Idaho", abbreviation: "ID", rate: 1748 },
  { label: "Oregon", value: "Oregon", abbreviation: "OR", rate: 1976 },
  { label: "California", value: "California", abbreviation: "CA", rate: 2052 },
  { label: "Washington", value: "Washington", abbreviation: "WA", rate: 2052 },
  { label: "Nevada", value: "Nevada", abbreviation: "NV", rate: 2352 },
];

  export const atvData = [
    { label: "Florida", value: "Florida", abbreviation: "FL", rate: 500 },
    { label: "Georgia", value: "Georgia", abbreviation: "GA", rate: 660 },
    { label: "South Carolina", value: "South Carolina", abbreviation: "SC", rate: 500 },
    { label: "Alabama", value: "Alabama", abbreviation: "AL", rate: 640 },
    { label: "North Carolina", value: "North Carolina", abbreviation: "NC", rate: 700 },
    { label: "Tennessee", value: "Tennessee", abbreviation: "TN", rate: 950 },
    { label: "Kentucky", value: "Kentucky", abbreviation: "KY", rate: 950 },
    { label: "Mississippi", value: "Mississippi", abbreviation: "MS", rate: 850 },
    { label: "Louisiana", value: "Louisiana", abbreviation: "LA", rate: 900 },
    { label: "Delaware", value: "Delaware", abbreviation: "DE", rate: 1081.50 },
    { label: "Maryland", value: "Maryland", abbreviation: "MD", rate: 990 },
    { label: "West Virginia", value: "West Virginia", abbreviation: "WV", rate: 1056 },
    { label: "Indiana", value: "Indiana", abbreviation: "IN", rate: 1023 },
    { label: "Ohio", value: "Ohio", abbreviation: "OH", rate: 990 },
    { label: "Pennsylvania", value: "Pennsylvania", abbreviation: "PA", rate: 957 },
    { label: "New Jersey", value: "New Jersey", abbreviation: "NJ", rate: 882 },
    { label: "Maine", value: "Maine", abbreviation: "ME", rate: 1200 },
    { label: "New Hampshire", value: "New Hampshire", abbreviation: "NH", rate: 1489 },
    { label: "Vermont", value: "Vermont", abbreviation: "VT", rate: 1700 },
    { label: "Massachusetts", value: "Massachusetts", abbreviation: "MA", rate: 1220 },
    { label: "Connecticut", value: "Connecticut", abbreviation: "CT", rate: 1050 },
    { label: "Rhode Island", value: "Rhode Island", abbreviation: "RI", rate: 1315 },
    { label: "New York", value: "New York", abbreviation: "NY", rate: 1250 },
    { label: "Virginia", value: "Virginia", abbreviation: "VA", rate: 850 },
    { label: "Michigan", value: "Michigan", abbreviation: "MI", rate: 950 },
    { label: "Iowa", value: "Iowa", abbreviation: "IA", rate: 1145 },
    { label: "Kansas", value: "Kansas", abbreviation: "KS", rate: 900 },
    { label: "Alaska", value: "Alaska", abbreviation: "AK", rate: 2625 },
    { label: "Arkansas", value: "Arkansas", abbreviation: "AR", rate: 924 },
    { label: "Missouri", value: "Missouri", abbreviation: "MO", rate: 996 },
    { label: "Illinois", value: "Illinois", abbreviation: "IL", rate: 960 },
    { label: "Texas", value: "Texas", abbreviation: "TX", rate: 924 },
    { label: "Oklahoma", value: "Oklahoma", abbreviation: "OK", rate: 1050 },
    { label: "Nebraska", value: "Nebraska", abbreviation: "NE", rate: 1200 },
    { label: "Wisconsin", value: "Wisconsin", abbreviation: "WI", rate: 1155 },
    { label: "Minnesota", value: "Minnesota", abbreviation: "MN", rate: 1200 },
    { label: "Colorado", value: "Colorado", abbreviation: "CO", rate: 1184 },
    { label: "South Dakota", value: "South Dakota", abbreviation: "SD", rate: 1314 },
    { label: "North Dakota", value: "North Dakota", abbreviation: "ND", rate: 1278 },
    { label: "New Mexico", value: "New Mexico", abbreviation: "NM", rate: 1596 },
    { label: "Arizona", value: "Arizona", abbreviation: "AZ", rate: 1260 },
    { label: "Montana", value: "Montana", abbreviation: "MT", rate: 1610 },
    { label: "Wyoming", value: "Wyoming", abbreviation: "WY", rate: 1562 },
    { label: "Utah", value: "Utah", abbreviation: "UT", rate: 1679 },
    { label: "Idaho", value: "Idaho", abbreviation: "ID", rate: 1679 },
    { label: "Oregon", value: "Oregon", abbreviation: "OR", rate: 1898 },
    { label: "California", value: "California", abbreviation: "CA", rate: 1890 },
    { label: "Washington", value: "Washington", abbreviation: "WA", rate: 1836 },
    { label: "Nevada", value: "Nevada", abbreviation: "NV", rate: 2464 }
  ];
  
  export const heavyMachineryData = [
    { label: "Florida", value: "Florida", abbreviation: "FL", rate: 1280 },
    { label: "Georgia", value: "Georgia", abbreviation: "GA", rate: 2640 },
    { label: "South Carolina", value: "South Carolina", abbreviation: "SC", rate: 2000 },
    { label: "Alabama", value: "Alabama", abbreviation: "AL", rate: 2560 },
    { label: "North Carolina", value: "North Carolina", abbreviation: "NC", rate: 2800 },
    { label: "Tennessee", value: "Tennessee", abbreviation: "TN", rate: 3800 },
    { label: "Kentucky", value: "Kentucky", abbreviation: "KY", rate: 3800 },
    { label: "Mississippi", value: "Mississippi", abbreviation: "MS", rate: 3400 },
    { label: "Louisiana", value: "Louisiana", abbreviation: "LA", rate: 3600 },
    { label: "Delaware", value: "Delaware", abbreviation: "DE", rate: 4200 },
    { label: "Maryland", value: "Maryland", abbreviation: "MD", rate: 4000 },
    { label: "West Virginia", value: "West Virginia", abbreviation: "WV", rate: 4400 },
    { label: "Indiana", value: "Indiana", abbreviation: "IN", rate: 4400 },
    { label: "Ohio", value: "Ohio", abbreviation: "OH", rate: 4400 },
    { label: "Pennsylvania", value: "Pennsylvania", abbreviation: "PA", rate: 4400 },
    { label: "New Jersey", value: "New Jersey", abbreviation: "NJ", rate: 4200 },
    { label: "Arkansas", value: "Arkansas", abbreviation: "AR", rate: 4400 },
    { label: "Missouri", value: "Missouri", abbreviation: "MO", rate: 4800 },
    { label: "Illinois", value: "Illinois", abbreviation: "IL", rate: 4800 },
    { label: "Texas", value: "Texas", abbreviation: "TX", rate: 4800 },
    { label: "Virginia", value: "Virginia", abbreviation: "VA", rate: 3400 },
    { label: "Michigan", value: "Michigan", abbreviation: "MI", rate: 4800 },
    { label: "New York", value: "New York", abbreviation: "NY", rate: 4800 },
    { label: "Connecticut", value: "Connecticut", abbreviation: "CT", rate: 4800 },
    { label: "Rhode Island", value: "Rhode Island", abbreviation: "RI", rate: 5000 },
    { label: "Massachusetts", value: "Massachusetts", abbreviation: "MA", rate: 5200 },
    { label: "Maine", value: "Maine", abbreviation: "ME", rate: 5600 },
    { label: "Kansas", value: "Kansas", abbreviation: "KS", rate: 5600 },
    { label: "Iowa", value: "Iowa", abbreviation: "IA", rate: 5600 },
    { label: "New Hampshire", value: "New Hampshire", abbreviation: "NH", rate: 5600 },
    { label: "Vermont", value: "Vermont", abbreviation: "VT", rate: 5600 },
    { label: "Oklahoma", value: "Oklahoma", abbreviation: "OK", rate: 5600 },
    { label: "Nebraska", value: "Nebraska", abbreviation: "NE", rate: 6000 },
    { label: "Wisconsin", value: "Wisconsin", abbreviation: "WI", rate: 6000 },
    { label: "Minnesota", value: "Minnesota", abbreviation: "MN", rate: 6400 },
    { label: "Colorado", value: "Colorado", abbreviation: "CO", rate: 6400 },
    { label: "South Dakota", value: "South Dakota", abbreviation: "SD", rate: 7200 },
    { label: "North Dakota", value: "North Dakota", abbreviation: "ND", rate: 7200 },
    { label: "New Mexico", value: "New Mexico", abbreviation: "NM", rate: 7600 },
    { label: "Arizona", value: "Arizona", abbreviation: "AZ", rate: 8000 },
    { label: "Montana", value: "Montana", abbreviation: "MT", rate: 9200 },
    { label: "Wyoming", value: "Wyoming", abbreviation: "WY", rate: 8800 },
    { label: "Utah", value: "Utah", abbreviation: "UT", rate: 9200 },
    { label: "Idaho", value: "Idaho", abbreviation: "ID", rate: 9200 },
    { label: "Oregon", value: "Oregon", abbreviation: "OR", rate: 10400 },
    { label: "California", value: "California", abbreviation: "CA", rate: 10800 },
    { label: "Washington", value: "Washington", abbreviation: "WA", rate: 10800 },
    { label: "Nevada", value: "Nevada", abbreviation: "NV", rate: 11200 },
    { label: "Alaska", value: "Alaska", abbreviation: "AK", rate: 15200 },
    { label: "Hawaii", value: "Hawaii", abbreviation: "HI", rate: 19600 },
  ];
  